// extracted by mini-css-extract-plugin
export default {"description":"Messengers_description__d7xPj"};